import {Component} from '@angular/core';
import {UserApiService} from '../api/user-api.service';
import {AuthService} from '../api/auth.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SharedService} from '../api/shared-service';
import {ToastrService} from 'ngx-toastr';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize} from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.css',
})
export class LoginComponent {
    loginData = {email: '', password: ''};
    loginError = false; // Flag for displaying error message
    loginForm: FormGroup;

    constructor(
        private userapiService: UserApiService,
        private router: Router,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private sharedService: SharedService,
        private authService: AuthService,
        private spinner: SpinnerService
    ) {
        this.loginForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]], // Email field
            password: ['', [Validators.required, Validators.minLength(6)]], // Password field
        });


        if (sessionStorage.getItem('username') !== null) {
            sessionStorage.removeItem('username');
            sessionStorage.removeItem('userRole');
            sessionStorage.removeItem('chapter');
            sessionStorage.removeItem('access_token');
            sessionStorage.removeItem('refresh_token');
            sessionStorage.removeItem('rolesPermission');
            sessionStorage.removeItem('userGroup');
            sessionStorage.removeItem('roleScope');
            sessionStorage.removeItem('userId');


            this.sharedService.setDivVisibility(false); // Or false to hide

            this.toastr.success('User logged out successfully!', 'Success');

        }


    }

    /*
      login(): void {
        // Call the login API
        console.log('Login called');
        if (this.loginForm.valid) {
          this.userapiService.login(this.loginData).subscribe(
            (response) => {
              this.userapiService.getRole(response.role).subscribe(
                (roleResponse) => {
                  // Store role permissions in session storage
                  sessionStorage.removeItem('userRole');
                  sessionStorage.setItem('userRole', JSON.stringify(roleResponse));
                  sessionStorage.setItem('userGroup', response.roles);
                  sessionStorage.setItem('roleScope', response.roleScope || 'SELF');
                  this.sharedService.updateUserRole( JSON.parse(roleResponse || '{}')); // 👈 broadcast change to all listening components
                debugger;
                },
                (error) => {
                  console.error('Error fetching role permissions', error);
                }
              );
              // Store user ID in session storage


              sessionStorage.setItem('username', response.id);
              sessionStorage.setItem('chapter', response.chapterAffiliation);
              this.sharedService.setDivVisibility(true); // Or false to hide

              this.router.navigate(['/profile']);
              this.loginError = false; // Reset the error flag
            },
            (error) => {
              console.error('Login failed', error);
              this.loginError = true; // Display error message
            }
          );
        }
      }
    */

    loginWithJWt() {
        if (this.loginForm.valid) {
            this.spinner.show(); // ✅ Show spinner before API call

            this.authService.login(this.loginData)
                .pipe(finalize(() => this.spinner.hide())) // ✅ Always hide spinner after API call
                .subscribe({
                    next: (response: any) => {
                        if (response !== null) {
                            sessionStorage.setItem('access_token', response.accessToken);
                            sessionStorage.setItem('username', response.username);
                            sessionStorage.setItem('userRole', response.roles);
                            sessionStorage.setItem('userGroup', response.roles);
                            sessionStorage.setItem('roleScope', response.roleScope || 'SELF');
                            sessionStorage.setItem('rolesPermission', JSON.stringify(response.rolesPermission));
                            sessionStorage.setItem('chapter', response.chapterId);
                            sessionStorage.setItem('userId', response.userId);
                            sessionStorage.setItem('refresh_token', response.refreshToken);

                            this.sharedService.updateUserRole(JSON.stringify(response.rolesPermission));
                            this.sharedService.setDivVisibility(true);

                            this.router.navigate(['/profile']);
                        }
                    },
                    error: (err) => {
                        console.error('Login error:', err);
                        this.toastr.error('Username or Password may be incorrect!', 'Error');
                    }
                });
        }
    }

    get email() {
        return this.loginForm.get('email');
    }

    get password() {
        return this.loginForm.get('password');
    }
}
